import React from 'react';
import { useSelector } from 'react-redux';


import HeaderLoader from './HeaderLoader';

const HeaderLogInOut = () => {
    const menuState = useSelector(state => state.reader?.user_menu_state);
    const links = useSelector(state => state.reader?.links);

    if (menuState === 'loading') return <HeaderLoader />;

    if (menuState === 'logged_in') {
        return (
            <div className='flex items-center'>
                <span className='font-semibold material-symbols-outlined'>
                        person
                    </span>
                    <a href={`${links.logout}?redirect=${encodeURIComponent(window.location.href)}`} className='text-base sm:text-sm font-space-grotesk'>
                        Logout
                    </a>
                    <span className='text-base sm:text-sm px-1'>|</span>
                    <a
                        className='text-base sm:text-sm font-space-grotesk'
                        href={links.account}
                    >
                        Account
                    </a>
            </div>
        );
    }

    if (menuState === 'logged_in_no_user') {
        return (
            <div className='flex items-center'>
                <span className='font-semibold material-symbols-outlined'>
                        person
                    </span>
                    <a href={`${links.logout}?redirect=${encodeURIComponent(window.location.href)}`} className='text-base sm:text-sm font-space-grotesk'>
                        Logout
                    </a>
            </div>
        );
    }

    return (
        <div className='flex items-center'>
            <span className='font-semibold material-symbols-outlined'>
                person
            </span>
            <a href={`${links.login}?redirect=${encodeURIComponent(window.location.href)}`} className='text-base sm:text-sm font-space-grotesk'>
                Login
            </a>
        </div>
    );
};

export default HeaderLogInOut;
